import axios from "axios";

const config = {
  withCredentials: true,
  headers: {
    withCredentials: true,
  },
};

const cleanParam = (value) => {
  if (value == null) return "";
  const text = String(value).trim();
  if (!text || text === "null" || text === "undefined" || text === "All") {
    return "";
  }
  return text;
};

const getResult = (data) => data?.data?.result;

export const getInventoryStockSummaryYears = async () => {
  try {
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/inventory-stock-summary-years`,
      config
    );
    return getResult(data) || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getInventoryStockSummaryMonths = async (year) => {
  const selectedYear = cleanParam(year);
  if (!selectedYear) return [];
  try {
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/inventory-stock-summary-months?year=${encodeURIComponent(
        selectedYear
      )}`,
      config
    );
    return getResult(data) || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getInventoryStockSummaryInvoices = async (inputs = {}) => {
  try {
    const urlParams = new URLSearchParams();
    const from = cleanParam(inputs.from);
    const to = cleanParam(inputs.to);
    const year = cleanParam(inputs.year);
    const month = cleanParam(inputs.month);
    if (from) urlParams.set("from", from);
    if (to) urlParams.set("to", to);
    if (year) urlParams.set("year", year);
    if (month) urlParams.set("month", month);

    const query = urlParams.toString();
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/inventory-stock-summary-invoices${
        query ? `?${query}` : ""
      }`,
      config
    );
    return getResult(data) || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const downloadInventoryStockSummaryReport = async (inputs = {}) => {
  try {
    const urlParams = new URLSearchParams();
    const from = cleanParam(inputs.from);
    const to = cleanParam(inputs.to);
    const year = cleanParam(inputs.year);
    const month = cleanParam(inputs.month);
    const invoiceNo = cleanParam(inputs.invoice_no);
    if (from) urlParams.set("from", from);
    if (to) urlParams.set("to", to);
    if (year) urlParams.set("year", year);
    if (month) urlParams.set("month", month);
    if (invoiceNo) urlParams.set("invoice_no", invoiceNo);

    const query = urlParams.toString();
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/inventory-stock-summary-excel${
        query ? `?${query}` : ""
      }`,
      config
    );
    const result = getResult(data);
    if (typeof result === "string" && /^https?:\/\//i.test(result.trim())) {
      return { url: result.trim(), message: data?.data?.message };
    }
    return {
      url: null,
      message: data?.data?.message || "No Result Found",
    };
  } catch (error) {
    console.log(error);
    return {
      url: null,
      message: error?.response?.data?.message || "No Result Found",
    };
  }
};
